// src/services/apiBaseUrl.js
// Pure resolver for the backend API base URL. Kept free of module-level
// imports with side effects (axios, host/*, etc.) so it can
// be imported in isolation by tests without pulling in the whole services/api
// dependency graph. `api.js` imports this and calls it with real runtime
// values (host.type, localStorage, process.env, window.location.hostname).
export function resolveApiUrl({ hostType, backendEnv, envVar, hostname }) {
    // In production, if no API_URL is set, use the backend URL
    let url = envVar?.trim();

    if (!url) {
        if (hostType === 'capacitor') {
            // Capacitor apps are served from capacitor://localhost, so
            // hostname-based auto-detection below can't work — resolve
            // from the persisted backend-env preference instead.
            const env = backendEnv || 'prod';
            url = env === 'staging'
                ? 'https://depos-backend-staging-h76dptzhyq-ew.a.run.app'
                : 'https://api.aqana.uk';
        } else if (hostname === 'aqana.uk' || hostname === 'www.aqana.uk') {
            // Auto-detect based on current domain
            url = 'https://api.aqana.uk';
        } else if (hostname === 'staging.aqana.uk') {
            url = 'https://depos-backend-staging-h76dptzhyq-ew.a.run.app';
        } else if (hostname?.includes('depos-frontend-staging-h76dptzhyq-ew.a.run.app')) {
            url = 'https://depos-backend-staging-h76dptzhyq-ew.a.run.app';
        } else if (hostname?.includes('depos-frontend-h76dptzhyq-ew.a.run.app')) {
            url = 'https://depos-backend-h76dptzhyq-ew.a.run.app';
        } else {
            url = 'http://localhost:8000';
        }
    }

    // If it's a localhost URL, ensure it uses HTTP; otherwise use HTTPS
    if (url.includes('localhost') || url.includes('127.0.0.1')) {
        return url.startsWith('https://') ? url.replace('https://', 'http://') : url;
    } else {
        return url.startsWith('http://') ? url.replace('http://', 'https://') : url;
    }
}
